export class App {
    public static readonly AdminEmails = [
        "som.shrivastava@gmail.com",
        "MTALBOT@ebnet.org"
    ]
}